export const logFetchPrefix = "fetch "
